module.exports = __webpack_public_path__ + "img/nbv-review-fill.1147a9bc.svg";